import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { pricingActions } from '../';
import { PricingActions, PricingContentState } from '../types';

const initialPricingState: PricingContentState = {
  data: null,
  error: null,
  isError: false,
  isPending: false
};

const pricingContentReducer: Reducer<
  typeof initialPricingState,
  PricingActions
> = (state = initialPricingState, action) => {
  switch (action.type) {
    case getType(pricingActions.fetchPricingContentAsync.request): {
      return {
        ...state,
        isError: false,
        isPending: true
      };
    }
    case getType(pricingActions.fetchPricingContentAsync.success): {
      const { payload: pricingData } = action;

      return {
        ...state,
        data: pricingData,
        isError: false,
        isPending: false
      };
    }
    case getType(pricingActions.fetchPricingContentAsync.failure): {
      const { payload: newError } = action;

      return {
        ...state,
        error: newError,

        isError: true,
        isPending: false
      };
    }
    default:
      return state;
  }
};

export default pricingContentReducer;
